import React from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const BreadcrumbArrow = () => {
    return (
        <svg
            className='inline'
            fill='none'
            height={'11px'}
            viewBox='0 0 7 11'
            width={'9px'}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M1.24219 1.25781L5.48483 5.50045L1.24219 9.74309'
                stroke='black'/>
        </svg>

    );
};

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const Breadcrumb = ({
    title,
    parent,
    parentSlug,
}) => {

    return (
        <div className='layout-container flex flex-row items-center'>
            {parent && (
                <a
                    className='px-10 sm:px-5 md:px-10 type-style-7'
                    href={`/${parentSlug}`}>
                    {parent}
                </a>
            )}
            {title && (
                <>
                    <BreadcrumbArrow />
                    <h5
                        className='px-10 sm:px-5 md:px-10 type-style-7 inline'>
                        {title}
                    </h5>
                </>
            )}
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

Breadcrumb.propTypes = {
    parent: PropTypes.string,
    parentSlug: PropTypes.string,
    title: PropTypes.string
};

export default Breadcrumb;
